// extracted by mini-css-extract-plugin
export default {"formNameBox":"index_formNameBox_wqgh-","formName":"index_formName_Lg-Wf","formWarning":"index_formWarning_Mgx8H","formNameStart":"index_formNameStart_qXISg"};